import type { SVGProps } from 'react';
const SvgBorderOuter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#border_outer_svg__a)">
      <path
        fill="currentColor"
        d="M13 7h-2v2h2V7Zm0 4h-2v2h2v-2Zm4 0h-2v2h2v-2ZM3 3v18h18V3H3Zm16 16H5V5h14v14Zm-6-4h-2v2h2v-2Zm-4-4H7v2h2v-2Z"
      />
    </g>
    <defs>
      <clipPath id="border_outer_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBorderOuter;
